import config from '@/config.js';
import { msalClient } from '@/login.js';

// Per-route usage analytics — the app's only network egress besides Microsoft
// Graph. Extracted from classes.js, where it was an empty class used purely as a
// namespace for two static functions.

// The signed-in user's UPN/email, or '' if none. Also used to prefill email links.
export function getUser() {
    try {
        var accounts = msalClient.getAllAccounts();
        if (!accounts || accounts.length === 0) return '';
        return accounts[0].username;
    } catch {
        return '';
    }
}

// Fire-and-forget log of a route to the SpeedyLog webhook. Skipped on localhost,
// on /search paths, and on anything that smells like an access token (redactions).
export function logAction(action) {
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') return;
    action = action || '';
    if (action.indexOf('/search') === 0) return;
    if (action.indexOf('/code=') === 0 || action.indexOf('eyJ') !== -1) return; // smells like an access token
    var data = { username: getUser(), action: action };
    fetch(config.SPEEDYLOG_URL, {
        method: 'POST',
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
}
